import { render } from "./slider.md?vue&type=template&id=b206777a"
import script from "./slider.md?vue&type=script&lang=js"
export * from "./slider.md?vue&type=script&lang=js"
script.render = render

export default script